import { Nav } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Navbar from 'react-bootstrap/Navbar';
import Form from 'react-bootstrap/Form';
import styled, { keyframes } from 'styled-components';
import background from '../../assets/macbook.jpeg';
import pc from '../../assets/pc2.jpg';
import mali from '../../assets/mali-nobg3.png';
import maliPhone from '../../assets/mali-nobg-phone.png';

export const bounce = keyframes`
0%{
  bottom :  10px;
}
50% {
  bottom :  20px;
}
100% {
  bottom :  10px;
}
`;

const Arrow = styled.div`
  position: fixed;
  left: 50%;
  font-size: 2rem;
`;

export const BouncingArrow = styled(Arrow)`
  animation: 2s ${bounce} ease-out infinite;
  z-index: 2;
  color: #88aeec;
`;

export const StyledNavbar = styled(Navbar)`
  height: 60px;
`;
export const StyledIntro = styled.div`
  position: relative;
  height: 700px;
  text-align: center;
  padding: 8rem;
  background-color: #252a30;
  z-index: 1;

  &::before {
    content: '';
    opacity: 0.6;
    left: 0;
    top: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    background-image: url(${background});
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    z-index: -1;
  }
`;
export const IntroServices = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 1rem;
  text-align: justify;
`;
export const IntroHeader = styled.div`
  display: flex;
  justify-content: center;
  & h2 {
    font-size: 5rem;
    color: #ffffff;

    &::after {
      content: ' ';
      width: 100%;
    }
  }
`;
export const IntroService = styled.div``;
export const IntroServiceHeader = styled.h5`
  color: #ffffff;
  font-weight: 800;
`;
export const IntroServiceBody = styled.div`
  color: #ffffff;
`;
export const BaseContainer = styled.div`
  overflow-y: scroll;
  position: relative;
  height: ${({ height }) => `${height}px`};
`;
export const AppContainer = styled.div`
  padding-top: 65px;
  background: #202020;
  color: #ffffff;
  min-height: ${({ height }) => `${height}px`};
  @media only screen and (max-width: 600px) {
    padding-top: 10px;
  }
`;
export const AboutContainer = styled(AppContainer)`
  display: flex;
  flex-direction: column;
`;
export const HomeContainer = styled(AppContainer)``;
export const HeroContainer = styled.div`
  min-height: ${({ height }) => `${height}px`};
  background-image: url(${mali});
  background-size: contain;
  background-repeat: no-repeat;
  flex-grow: 1;
  background-position: right;
  width: 800px;
  margin: auto;
  margin-top: 100px;
  padding-top: 150px;
  @media only screen and (max-width: 600px) {
    background-image: url(${maliPhone});
    background-size: unset;
    background-position: 50% 100%;
    width: unset;
    margin: unset;
    margin-top: 100px;
    padding-top: unset;
  }
`;

export const HeroContainerLeft = styled.div`
  padding: 5rem 0 0 2rem;
  position: absolute;
  right: 600px;
`;

export const HeroContainerRight = styled.div``;

export const HeroText = styled.div`
  @media only screen and (max-width: 600px) {
    padding: 10px 25px;
  }
  margin-bottom: 2rem;
  & h2 span {
    color: #88aeec;
  }
`;
export const HeroSocial = styled.div`
  width: 180px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);

  @media only screen and (max-width: 600px) {
    width: 180px;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    padding-left: 20px;
  }
`;

export const SocialButton = styled(Button)`
  width: ${({ width }) => width || 30}px;
  margin-bottom: ${({ mb }) => mb || ''};
  height: 30px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
  color: #ababab;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0;
  border: 0;
  background: none;
  &:hover {
    background: none;
    & a {
      text-decoration: none;
      & svg {
        color: #88aeec;
      }
    }
  }
  & a {
    text-decoration: none;
    & svg {
      color: #ababab;
      font-size: 30px;
    }
  }
`;
export const SocialButtonTwitter = styled(SocialButton)``;
export const SocialButtonFacebook = styled(SocialButton)``;
export const SocialButtonLinkedin = styled(SocialButton)``;
export const SocialButtonGithub = styled(SocialButton)``;
export const SocialButtonInstagram = styled(SocialButton)``;

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;
export const PageHeading = styled.div`
  text-align: center;
`;
export const PageHeadingText = styled.h2`
  width: 300px;
  text-align: center;
  margin: auto;
  border-bottom: 10px solid #88aeec;
  border-radius: 10px;
  margin-bottom: 1rem;
`;
export const PageBody = styled.div`
  display: flex;
  flex-grow: 1;
  @media only screen and (max-width: 600px) {
    flex-direction: column;
  }
`;

export const AboutBodyLeft = styled.div`
  border-radius: 15px;
  margin-left: 20px;
  background-image: linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.25)), url(${pc});
  width: 350px;
  background-size: cover;

  @media only screen and (max-width: 600px) {
    display: none;
  }
`;

export const AboutBodyRight = styled.div`
  padding: 1rem;
  width: 65%;
  & p {
    font-size: 18px;
  }
  @media only screen and (max-width: 600px) {
    width: 100%;
    & p {
      font-size: 14px;
    }
  }
`;

export const AboutNavLink = styled(Nav.Link)`
  color: #ffffff;
  font-size: 18px;
  font-weight: 800;
  &.active {
    border-bottom: 2px solid #88aeec;
  }

  @media only screen and (max-width: 600px) {
    font-size: 14px;
    padding-left: 4px;
  }
`;

export const AboutImage = styled.img`
  width: 100%;
  background: #ffffff;
  border-radius: 15px;
`;
export const ResumePage = styled.div``;
export const ResumeCategory = styled.div`
  margin-bottom: 20px;
`;
export const ResumeBody = styled.div`
  display: flex;
  flex-direction: colum;
`;

export const ResumeCategoryHeader = styled.h3`
  background-color: #807d7d;
  color: #fff;
  height: 30px;
  line-height: 30px;
  font-size: 20px;
  padding-left: 10px;
  cursor: pointer;
  margin-bottom: 0;
`;
export const ResumeCategoryBody = styled.div`
  border-left: 1px solid grey;
  border-right: 1px solid grey;
  border-bottom: 1px solid grey;
  overflow-y: scroll;
  padding: 0.5em;
  height: 250px;

  &.collapsed {
    height: 0px;
    overflow: hidden;
    padding: 0;
  }
`;

export const ResumeCategorySkills = styled(ResumeCategoryBody)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 1em;
  & li {
    list-style: none;
  }
`;
export const ResumeExpItem = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  & h6 {
    font-size: 18px;
    font-weight: 400;
    margin-bottom: 10px;
  }
  & span {
    color: #88aeec;
    font-weight: 400;
    margin-bottom: 5px;
  }

  @media only screen and (max-width: 600px) {
    & h6 {
      font-size: 14px;
      font-weight: 400;
      margin-bottom: 5px;
    }
  }
`;

export const InterestsPanel = styled.div`
  width: 350px;
  min-height: 40px;
  line-height: 40px;
  border: 1px solid #000;
  border-radius: 5px;
  padding: 5px;
  vertical-align: middle;
  display: inline-block;
  cursor: pointer;
  background-color: #fff;
  margin-left: 10px;
  margin-bottom: 10px;
  -webkit-transition: height 0.3s ease-in-out, width 0.3s ease-in-out, top 0.3s ease-in-out,
    left 0.3s ease-in-out, z-index 0.3s ease-in-out;
  -o-transition: height 0.3s ease-in-out, width 0.3s ease-in-out, top 0.3s ease-in-out,
    left 0.3s ease-in-out, z-index 0.3s ease-in-out;
  transition: height 0.3s ease-in-out, width 0.3s ease-in-out, top 0.3s ease-in-out,
    left 0.3s ease-in-out, z-index 0.3s ease-in-out;
  &.collapsed {
    width: 250px;
  }
  &.greyedout {
    background-color: rgba(226, 226, 224, 0.67) !important;
  }
`;

export const InterestsPanelBody = styled.div`
  width: 100%;
  -webkit-transition: height 0.3s ease-in-out;
  -o-transition: height 0.3s ease-in-out;
  transition: height 0.3s ease-in-out;
  &.collapsed {
    height: 10px;
    overflow: hidden;
  }
`;

export const InterestPanelHeader = styled.div`
  height: 40px;
  border-bottom: 2px solid;
  display: flex;
  align-items: center;
`;

export const InterestPanelHeaderTitle = styled.div`
  display: flex;
  & div {
    margin-right: 10px;
  }
`;

export const CollapsedItems = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 0.25rem;
`;

export const OpenItem = styled.div`
  display: flex;
  justify-content: center;
`;

export const ContactSectionHeader = styled.div`
  display: flex;
  & h2 {
    font-size: 40px;
  }
  margin-bottom: 30px;

  @media only screen and (max-width: 600px) {
    padding: 0px;
    margin-left: auto;
    & h2 {
      font-size: 30px;
    }
    margin-bottom: 20px;
  }
`;
export const ContactPage = styled.div`
  display: flex;
  width: 80%;
  margin: auto;
`;
export const ContactLine = styled.div`
  display: flex;
  & p {
    margin: 0 0 0 10px;
    font-size: 18px;
  }
  & svg {
    color: #88aeec;
    font-size: 25px;
  }
  margin-bottom: 20px;
  align-items: center;

  @media only screen and (max-width: 600px) {
    & p {
      font-size: 14px;
    }
    margin-bottom: 10px;
  }
`;
export const ContactDownloadButton = styled(Button)`
  background: #114499;
  height: 50px;
  border: none;
  border: none;
`;
export const ContactSocial = styled.div`
  padding-left: 50px;
  padding-top: 50px;
  flex-basis: 40%;
  @media only screen and (max-width: 600px) {
    padding: 0px;
    & h2 {
      font-size: 25px;
    }
  }
`;
export const ContactForm = styled(Form)`
  padding-left: 50px;
  padding-top: 50px;
  flex-basis: 50%;
  @media only screen and (max-width: 600px) {
    padding: 0;
    margin-top: 20px;
    font-size: 14px;
  }
`;

export const ContactFormInput = styled(Form.Control)`
  background-color: rgba(226, 226, 224, 0.67) !important;
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 18px;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-image: none;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  margin: 0 0 20px;
  &.error {
    border-color: rgb(255 0 0 / 46%);
    box-shadow: none;
    border-width: 2px;
  }
`;
export const FormErrorText = styled(Form.Text)``;
export const ContactFormTextArea = styled(ContactFormInput)`
  resize: none;
`;

export const ContactFormFooter = styled(Form.Group)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ContactSection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContactSocialButtons = styled.div`
  width: 180px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  margin-bottom: 10px;
`;

export const AppFooter = styled.footer`
  width: 100%;
  height: 150px;
  background-color: #000;
  padding: 10px;
  text-align: center;

  & #short-contact {
    color: hsla(0, 0%, 100%, 0.3);

    & a {
      color: #a7a9ac;
      margin-left: 0.25rem;
    }
  }
`;

export const FooterLi = styled.li`
  display: inline-block;
  padding-top: 0.3125rem;
  padding-bottom: 0.3125rem;
  margin-right: 1rem;
  font-size: 15px
  line-height: inherit;
  white-space: nowrap;
`;

export const HeroImg = styled.img`
  position: absolute;
  right: 100px;
  width: 720px;
  height: 480px;
`;

export const PageNavHolder = styled.div`
  display: block;
  margin: auto;
  width: ${({ width }) => width};
  text-align: center;
  z-index: 10;
  top: ${({ shouldStick }) => (!shouldStick ? '' : 0)}px;
  position: ${({ shouldStick }) => (!shouldStick ? '' : 'fixed')};
  @media only screen and (max-width: 600px) {
    top: 0px;
    right: 0;
    position: fixed;
    width: auto;
    display: none;
    height: 100%;
  }
`;

export const PageNav = styled.ul`
  position: relative;
  height: 50px;
  background-color: #ffffff;
  color: #000000;
  @media only screen and (max-width: 600px) {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 10px 20px;
  }
`;

export const PageControl = styled.div`
  display: none;
  @media only screen and (max-width: 600px) {
    display: inherit;
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 30px;
    color: #88aeec;
  }
`;

export const PageControlClose = styled.div`
  display: none;
  @media only screen and (max-width: 600px) {
    display: inherit;
    font-size: 30px;
    color: #88aeec;
    display: flex;
    justify-content: flex-end;
  }
`;
export const PageNavBrand = styled.li`
  position: absolute;
  width: 50px;
  left: 1%;
  display: inline-block;
  padding-top: 0.3125rem;
  padding-bottom: 0.3125rem;
  margin-right: 1rem;
  font-size: 15px;
  line-height: inherit;
  white-space: nowrap;
  @media only screen and (max-width: 600px) {
    position: relative;
    display: none;
  }
`;

export const PageNavItem = styled.li`
  display: inline-block;
  width: 125px;
  height: 50px;
  vertical-align: middle;
  cursor: pointer;
  color: #88aeec;
  font-weight: 700;
  line-height: 50px;
  & a {
    color: inherit;
    text-decoration: none;
  }
  &.active {
    border-bottom: 5px solid #88aeec;
  }
  @media only screen and (max-width: 600px) {
    width: unset;
  }
`;

export const PortfolioBody = styled.div`
  padding-right: 20px;
  padding-left: 20px;
`;
export const PortfolioSection = styled.div`
  margin-bottom: 10px;
`;
export const PortfolioSectionHeader = styled.h1`
  margin-bottom: 10px;
  font-size: 20px;
  font-weight: 800;
`;
export const PortfolioSectionBody = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  @media only screen and (max-width: 600px) {
    justify-content: center;
  }
`;
export const PortfolioSectionItem = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 20px;
  margin-bottom: 20px;
  padding: 10px;
  border: 4px solid var(--theme-light-grey);
  height: 220px;
  width: calc(50% - 20px);
  background-position: 0% 50%;
  color: var(--theme-light-grey);
  &:hover {
    background-size: 400%;
    background-position: 100% 50%;
    transition: background-position 0.4s, color 0.4s;
    color: var(--theme-light-purple);
    background-image: linear-gradient(
      45deg,
      #1e1e1e8a 0%,
      #999999a3 20%,
      #a83efe59 40%,
      #a83efe9e 60%,
      #006affb3 80%,
      #006affc4 100%
    );
    transform: scale(1.05);
    z-index: 1;
    border: 4px solid var(--theme-light-grey);
  }
  @media only screen and (min-width: 60em) {
    width: calc(33.33333% - 20px);
  }
  @media only screen and (max-width: 600px) {
    width: calc(100% - 20px);
    margin-right: 0px;
  }
`;

export const PortfolioSectionItemDescription = styled.p`
  flex-grow: 2;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow-y: hidden;
  display: -webkit-box;
`;
export const PortfolioSectionItemLink = styled.a`
  place-self: flex-end;
  color: var(--theme-light-grey);
  text-decoration: none;
  &:hover {
    color: var(--theme-light-purple) !important;
    font-weight: 800;
  }
`;
export const PortfolioSectionItemHeader = styled.h1`
  font-size: 22px;
  font-weight: 800;
`;

export const PortfolioText = styled.p`
  font-size: 18px;
`;
